module.exports = __webpack_public_path__ + "static/media/tune-anytime.8269a2b6.svg";